// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3fNdR","productName":"Table_productName__1lMVO"};